import { useRouter } from 'next/router';

import Button from '~/src/common/components/Button';
import Icon from '~/src/common/components/Icon';
import I18n from '~/src/common/services/I18n';

import * as S from './layout';

const EmptyLarge = () => {
  const router = useRouter();
  const goHome = () => void router.push('/');

  return (
    <S.EmptyLargeContainer>
      <Icon name="Empty" />
      <h2>{I18n.t('category.empty.large.title')}</h2>
      <p>{I18n.t('category.empty.large.text')}</p>
      <Button onClick={goHome}>{I18n.t('category.empty.large.btn')}</Button>
    </S.EmptyLargeContainer>
  );
};

export default EmptyLarge;
